import { z } from 'zod';

/**
 * Schemas de OrdemServico (SPEC §8). A OS é criada dentro da transação de
 * cadastro (§6.1), nunca por um POST solto — aqui só consulta e cancelamento.
 */

export const listarOrdensQuerySchema = z.object({
  clienteId: z.string().uuid().optional(),
  /**
   * Busca a OS pelo `numero_os` exato (UX-PAINEL-INTERNO §5, E4). Quando
   * presente, a resposta é a OS única (ou 404 `nao_encontrado`), não a lista.
   */
  numero: z.string().trim().min(1).optional(),
  pagina: z.coerce.number().int().positive().default(1),
  limite: z.coerce.number().int().positive().max(100).default(20),
});
export type ListarOrdensQuery = z.infer<typeof listarOrdensQuerySchema>;

export const cancelarOrdemSchema = z.object({
  motivo: z.string().trim().min(1, 'Informe o motivo do cancelamento'),
});
export type CancelarOrdemInput = z.infer<typeof cancelarOrdemSchema>;
